import L from 'leaflet';
import proj4 from 'proj4';
import * as Reproject from 'reproject';
import { ClusteredMarkerLayer } from '../Layers/ClusteredMarkersLayer';
import type { ClusteredMarkerLayerOptions } from '../Layers/Layers.types';
import Situation from '../PopupTemplates/Situation';
import { SituationSource } from '../Sources/SituationSource';
import { affectedArea } from './AffectedArea';

export const bikeSituation = function (region: string, geoPageId?: number, options?: ClusteredMarkerLayerOptions): ClusteredMarkerLayer {
    const defaultOptions: ClusteredMarkerLayerOptions = {
        name: 'Gång- och cykelvägsstörning',
        itemPlural: 'störningar',
        popupTemplate: Situation,
        source: new SituationSource(region, 'Cykeltrafik', geoPageId, {
            updateInterval: 60,
        }),
        combinationIcon: true,
        createInformationLayer: function (feature) {
            const layers = [];
            if (feature.properties.sweRef99Extent) {
                layers.push(
                    affectedArea(
                        Reproject.toWgs84(
                            feature.properties.sweRef99Extent,
                            '+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs',
                            proj4,
                        ),
                        { arrowDirection: feature.properties.affectedDirection },
                    ),
                );
            }
            if (feature.properties.sweRef99Area) {
                layers.push(
                    affectedArea(
                        Reproject.toWgs84(
                            feature.properties.sweRef99Area,
                            '+proj=utm +zone=33 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs',
                            proj4,
                        ),
                    ),
                );
            }
            return layers.length > 0 ? L.layerGroup(layers) : null;
        },
        persistentInformationLayer: false,
        onMarkerAdd: function (marker, feature) {
            marker.getElement().setAttribute('data-situation-id', feature.properties.id);
        },
    };

    return new ClusteredMarkerLayer({ ...defaultOptions, ...options });
};
